export enum AcknowledgeResult {
  ok,
}
export enum ConfirmationResult {
  yes,
  no,
}

export enum NewStudyDialogResult {
  cancelled,
  goToMyStudies,
  goToQuantitativeSearch,
  goToSearchStudies,
}

export enum LogoutReasonCode {
  userLoggedOut,
  webapiRefreshTokenExpired,
  inactiveSessionTimeout,
  invalidUserAccess,
}

export enum RouterLink {
  MyStudies = '/study',
  SearchStudies = '/search',
  Dashboard = '/dashboard',
  NotFound = '/notfound',
  CancelPrivacyNotice = 'cancelprivacynotice',
  NoStudyAccess = 'nostudyaccess',
  LegacySearchStudies = '/legacy/search',
  LegacyMyStudies = '/legacy/study',
}

export enum ResultMessage {
  BulkStatusChanged = 'Status Change(s) saved successfully.',
  SearchStrategyCreated = 'Search Strategy created successfully.',
  SearchStrategyUpdated = 'Search Strategy updated successfully.',
  FilterExecuted = 'Filter(s) executed successfully.',
  CommentSaved = 'Comment saved successfully.',
  NoDataForDownload = 'There is no data available for downloading.',
  FileUploaded = 'File uploaded successfully.',
  UnexpectedError = 'Something went wrong, please try again later.',
  ErrorEncountered = 'Error encountered during save',
  RequiredFields = 'Please complete the required fields in red',
  FinancialDetails = 'Financial Detail Saved Successfully',
  MultiUserOnSearchStrategyError = 'Filter has been modified by another user{user}, please refresh the page and apply filter changes again.',
}

export enum ConfirmationMessage {
  UnsavedModifications = 'Any unsaved modifications will be lost. Are you sure you want to Cancel?',
  AffectOtherAspects = 'The changes you are making could affect other aspects of the study. Are you sure you want to save the changes?',
  DownstreamConsequences = 'Warning: Revisions made at this juncture may have downstream consequences to work already performed. Please review work based on changes implemented. Are you sure you want to save the changes?',
  ConfirmDiscardChanges = 'Are you sure you want to leave this page without saving your changes?',
  ConfirmLogout = 'Are you sure your want to sign out?',
  ConfirmLogoutUnsavedChanges = 'There are unsaved changes within this study.  Please save any information before signing out.  Do you wish to continue signing out?',
  AcknowledgeDiscardChanges = 'We will leave this page without saving your changes.',
  EliminationCategory = 'Are you sure you want to remove this column?',
  EliminationCriteria = 'This change will delete all the crosses checked under this column. Please check before you delete. Are you sure you want to remove this column now?',
  FilterChanged = 'Any unsaved changes to the filter will be lost. Are you sure you want to Cancel?',
  RemoveUser = 'Are you sure you want to remove this user?',
  DeleteFilter = 'Are you sure you want to delete this filter?',
  StudySettings = 'Modifying any one of these settings will modify the results of your study. Any manual steps performed prior to this stage should be reviewed for accuracy.',
  FinancialSetting = 'This financial item is needed for one of the PLI ratios selected. Deselecting this financial item will also deselect the PLI ratio selected.  Is this OK?',
  ComparableDataTypeSetting = 'This change will have impact on the result of search strategy. The search strategy should be re-executed and any account type filters will be removed. Are you sure you want to proceed? ',
  ComparableSettingChangeForAdjustedValue = 'This change will have impact on the result of search strategy and on the raw data used in the financial adjustment. Changing the settings will result in below actions:<br/><br/>\
    <ul> <li> The search strategy should be re-executed and any account type filters will be removed.</li>\
    <li> Changing the type of financials after an import of adjusted financial data will remove the current adjusted values.</li> </ul>\
    Are you sure you want to proceed?',
  CurrencySetting = 'Changing the currency unit after an import of adjusted financial data will remove the current adjusted values.  Are you sure you want to proceed?',
  FinancialConsolidateChange = 'Changing the type of financials for this individual company will only change the financial view on this screen. The types of financials selected in the search strategy screen will still be applied to all companies throughout the study.',
  FinancialFilingTypeChange = 'Changing the filing type for this individual company will only change the financial view on this screen. The filing type selected in the search strategy screen will still be applied to all companies throughout the study.',
  DeleteScreenshot = 'Are you sure you want to delete this screenshot?',
  DeleteStudy = 'Confirm deletion of study, ',
  ManageScreenshotUnsavedMsg = 'Updates on this page have not been saved. Are you sure you want exit without saving?  Yes or No.',
  AffectOtherAspectsPredictionEngineReset = 'Please note that all AI/ML predictions in BDR tab will be reset. The AI/ML prediction engine will have to be executed again to view the updated recommendations.',
  AffectOtherAspectsPeriodofStudyChange = 'This updated Period of Study setting will affect certain aspects of the study. All filters which include the Period of Study  will get removed because the Period Beginning or Period Ending has changed. Are you sure you want to save the changes?',
  AffectOtherConsolidatedStudyPeriodMsg = 'This updated Period of Study setting will affect certain aspects of the study. \
                                        All filters which include the Period of Study  will get removed because the Period Beginning or Period Ending has changed.',
  StudyChangeConsolidatedMsg = 'The changes you are making could affect other aspects of the study. Are you sure you want to proceed? <br/> <br/>',
  DeleteInterestRateFile = 'Are you sure you want to delete this Interest rate file?',
  ManageInterestRateFileUnsavedMsg = 'Updates on this page have not been saved. Are you sure you want exit without saving?  Yes or No.',
  EditInterestRateFileMsg = 'Note that either Document or Source is mandatory. Please upload a new interest rate document or enter Source and click on Edit button, and try again.',
  AffectAdjustmentDataMsg = 'This change will impact financial data and adjustment calculations in the adjustment tab.',
  RemoveFilterMsg = 'Warning: The changes you are making would remove existing filters. Are you sure you want to save the changes?​',
  ConfirmCompanySlideOutClose = 'Are you sure you want to close this dialog?',
  DeleteTestedParty = 'Are you sure you want to delete the selected tested party?',
  MissingFinancialdataDataMsg = 'Selected data feed does not contain financial data for at least one year from pre selected period of study',
  WelcomeScreenConfirmationMessage = '<div class="row">\
  <div class="col-1 modal-confirmation">\
  <span class="material-icons error-icon">error</span></div>\
  <div class="col-11"><p><strong>Warning: You have selected the non-audit approved (Generative Al) version of the TP Benchmark. This version is strictly prohibited for audit use.</strong> <br/> <br/><strong>Click the Back button</strong> to return to the audit-approved version.<br/> <br/>If you intend to proceed with the non-audit approved version of TP Benchmark, please confirm by clicking \'Acknowledge\' - <strong>understanding that this version of TP Benchmark cannot be used for any audit purposes.</strong></p>\
  </div>\
  </div>',
  ConfirmLIFOAdjustmentToAll = `Apply LIFO Adjustment to all companies/years where it's applicable within Study?`,
  ConfirmRemoveLIFOAdjustmentFromAll = `Remove LIFO Adjustment from all companies/years where it's applicable within Study?`,
}

export enum WarningMessage {
  UnsavedAnalysis = 'Unsaved changes on Analysis tab',
  FiltersChanged = 'Search Strategy Filters changed on Analysis tab',
  DatabaseChanged = 'Search Strategy Search Database changed on Analysis tab',
  ExecutionChanged = 'Search Strategy Execution not saved on Analysis tab',
  BooleanExpressionChanged = 'Boolean Search expression not saved on Analysis tab',
  FilterSelectionChanged = 'Search filter selection not saved on Analysis tab',
  ComparableDetailsChanged = 'Updates on this page have not been saved.  Are you sure you want exit without saving?',
  RejectionReasonRequiredBDR = 'Rejection Reason is required for rejected comparables',
  DecisionCriteriaRequiredBDR = 'Decision Criteria is required',
  RejectionReasonAndUserDecisionRequiredBDR = 'Rejection Reason and Decision Criteria is required for comparables',
  StatusRequiredBDR = 'Status is required for comparables',
  RejectStatusRequiredBDR = 'All rejected comparables must have a decision criteria selected',
  EliminationCriteriaRequired = 'Rejection Reason and Decision Criteria are required for rejected comparables',
  InformationRequired = 'Information Required',
  AllRejectedMustBeCompleted = 'All rejected comparables must have a reason and decision criteria selected.  Please return to the Internet Review section to ensure all rejected comparables have the required information.',
  KeywordsChanged = 'Keywords list has been changed. Save it by executing keywords screening.',
  EliminationReviewNotChecked = 'Please confirm your decisions by checking "Reviewed" check box at the bottom of the screen.',
  ExportMatrixWarningMessage = 'Warning: Please do not modify the column headers in the Excel file after the export. Changes to the header names will cause the re-upload process to fail. Please review the Decision Criteria header and make necessary changes in the TP Benchmark before the export. After the export, you are free to alter accept/reject decisions within the rows, but the column headers must remain as they are exported.',
  ConfirmationRequired = 'Confirmation Required',
  TestedPartyChanged = 'Tested Party Information changed on Analysis tab',
}

export enum AcknowledgeMessage {
  ReportGenerationStarted = 'You will receive a <strong>notification shortly within this application</strong> when your report is ready for download.',
  DatabaseLicensing = 'You cannot take any actions on this study due to database licensing restrictions. If further assistance is needed, you should contact the local support team.',
  DatabaseAndReadOnlyLicensing = 'Due to database licensing and user access restrictions, you cannot take further action as to this study. Please connect with GDS or where appropriate, another EY practice, for additional benchmarking support.',
  ReadOnlyLicensing = 'Due to user access restrictions set by your practice, you can only read or review the study. Please connect with the preparer to implement any revisions.',
  UploadFileMessage = 'You will receive a <strong>notification shortly within this application</strong> when your Excel file is uploaded successfully.',
  UploadScreenshotMessage = 'You will receive a <strong>notification shortly within this application</strong> when your screenshots are uploaded successfully.',
  ReportStatusWarningMessage = 'The status for one of the comparable in this report is blank.',
  DownloadFileMessage = 'You will receive a <strong>notification shortly within this application</strong> when your Excel file is ready for download.',
  StudyViewed = 'The study is in use by another team member: ',
  ViewedOn = ',<br> Viewed On:',
  ScrapeStarted = 'You will receive a <strong>notification shortly within this application</strong> when your Scraper process is complete.',
  ScrapeDownloadStarted = 'You will receive a <strong>notification shortly within this application</strong> when your Scraper file is ready for download.',
  ExtractKeywordsStarted = 'You will receive a <strong>notification within this application</strong> when extract keywords is complete.',
  CaptureScreenshotStarted = 'You will receive a <strong>notification within this application</strong> when capture screenshot is complete.',
  ReportStatusWarningNeutral = 'There should be no comparables with Neutral status in order to generate Final report.',
  ExtractKeywordsInProgress = 'The keyword screening process is still in progress. Please wait for keyword screening to complete and then try again.',
  UpdateIndustrySectorBeforeInitiateAI = 'Please update Industry/Sector field at Tested Party Information section located at Study set-up.',
}

export enum ColumnHeaders {
  adjustedCalculation = 'Adjusted Calculation on "Selected PLIs"',
  booleanLogic = 'Boolean Logic',
  bvdId = 'ID Number',
  companyName = 'Company Name',
  country = 'Country',
  currencyInformation = 'Currency Information',
  database = 'Database',
  databaseInformation = 'Database Information',
  databaseVersion = 'Database version Date',
  eliminationCriteria = 'Elimination Criteria',
  filters = 'Filters',
  fullOverview = 'Full Overview',
  includeExcludeList = 'Include/Exclude List',
  industryCode = 'Industry Code',
  internalNotes = 'Internal Notes',
  iqr = 'Interquartile Range',
  keywordOccurrence = 'Occurrences of the keywords',
  numberAcceptReject = 'Number of companies accepted and rejected',
  numberOfCompanies = 'Number of companies',
  numberRetained = 'Number of companies retained',
  numberRetainedByStatus = 'Number of companies retained in each status',
  periodOfStudy = 'Period of Study',
  pliSettings = 'PLI Settings',
  rejectReason = 'Reason',
  status = 'Status',
  subset = 'Subset',
  tradeDescriptionEN = 'Trade Description (English)',
  tradeDescriptionNL = 'Trade Description (Local Language)',
  website = 'Website',
  websitesProvided = 'Websites provided by Vendor Db',
  websitesSelected = 'Websites selected',
  comment = 'Comment',
  websiteVendorProvided = 'Website - Vendor Database',
  websiteUserProvided = 'Website - User selected',
  reason = 'Reason',
  source = 'Source',
  exclusionReasons = 'Comments',
  numberOfCompaniesAccepted = 'Number of companies accepted',
  numberOfCompaniesRejected = 'Number of companies rejected',
  companyAddress = 'Company Address',
  tradeDescriptionTranslated = 'TD (translated)',
  IsDemoStudy = 'Is Demo Study',
  StudyID = 'StudyId',
  StudyName = 'Study Name',
  CreatedOn = 'CreatedOn',
  PreparerName = 'Preparer Name',
  PreparerEmail = 'Preparer Email',
  LicensingCountry = 'Licensing Country',
  ProjectOfficeCountry = 'Project Office Country',
  DatabaseNames = 'Database Names',
  StudyStatus = 'Study Status',
}

export enum ChangeType {
  StudyInfo = 'Changes to Study Information',
  TestedParty = 'Changes to Tested Party Information',
  StudyAccess = 'Changes to Study Access',
}

export enum RegularExpressionPattern {
  /*Allows  a-z, A-Z,
   *        0-9 (not allowed as the first letter for anything),
   *        _ (underscore) (not allowed as the first letter for anything),
   *        - (dash) (not allowed as the first letter for anything),
   *        (space) (not allowed as the first letter for anything) */
  BasicPattern = '^[a-zA-Z0-9]+[a-zA-Z0-9 _-]*',

  /*Allows  a-z, A-Z,
   *        0-9 (not allowed as the first letter for anything),
   *        _ (underscore) (not allowed as the first letter for anything),
   *        - (dash) (not allowed as the first letter for anything),
   *        (space) (not allowed as the first letter for anything)
   *        . (period) (not allowed as the first letter for anything)
   *        ; (semicolon) (not allowed as the first letter for anything)
   *        , (Comma) (not allowed as the first letter for anything)
   *        ' (apostrophe) (not allowed as the first letter for anything)*/
  AdvancedPattern = "^[a-zA-Z0-9]+[a-zA-Z0-9,;'.  _-]*",

  /* The same as advanced pattern plus allow enter key */
  BusinessDescPattern = "^[a-zA-Z0-9]+[a-zA-Z0-9\n,;'.  _-]*",
  /* The same as advanced pattern plus allow enter key */
  nonComparableCriteriaPattern = "^[a-zA-Z0-9]+[a-zA-Z0-9\n,;'.  _-]*",

  /* Allows A-Z, 0-9 * and . */
  BvdIdPattern = '^[a-zA-Z0-9*.]+[a-zA-Z0-9*., -]*$',

  /* Number only pattern */
  NumberPattern = '^[0-9]*$',
  /* Number only pattern with up to 2 decimal places */
  NumberWithDecimalPattern = '^[0-9]+(.[0-9]{1,2})?$',
}

export enum ViewResultCount {
  SearchCountId = 175,
}

export enum EliminationReviewChangeKey {
  EliminationReviewConfirmation = 'EliminationReviewConfirmation',
}

export enum AccessType {
  FullAccess = 1,
  NoAccess = 2,
  PartialAccess = 3,
}

// This enum is associated with EY.Tax.TPBenchmark.Common - GlobalEnum.cs
export enum FinancialDatAdjustmentErrorMessage {
  ERROR = 'Something went wrong, please try again later.',
  SUCCESS = 'Import successful!',
  INVALID_STUDY = 'Imported file does not have valid studyid.',
  INVALID_FILE = 'Imported file is invalid.',
  NOT_LATEST_FILE = 'Imported file does not match with last exported file.',
  INVALID_DATA = 'The document selected for import does not match the document exported. Please import the correct file.',
  NO_DATA_EXIST = 'There is no data available for download.',
  NO_MASTERMATRIX_DATA_EXIST = 'Master matrix does hot have accepted data.',
  NOT_AVAILABLE = 'N.A.', // not available due to value is null or error in formula.
  INVALID_REASON = 'Field length of Reason should not be greater than 1000 characters',
}

export const FunctionPredictionClassificationTypes = {
  0: 'Not Comparable Function',
  1: 'Comparable Function',
  2: 'N/A',
};

export const ProductPredictionClassificationTypes = {
  0: 'Not Comparable Product',
  1: 'Comparable Product',
  2: 'N/A',
};

export enum PredictionResultType {
  Comparable = 0,
  NonComparable = 1,
}

export enum ComponentType {
  myStudyHome = 'MyStudiesHomeComponent',
}

export const ToastMessageConfig = {
  SEVERITY_ERROR: 'error',
  AUTO_DISMISS_AFTER_MS: 10000,
};

export const AddFilterDialogMessages = {
  DISPLAY_ORDER_PROP_NAME: 'displayOrder',
  COMPANY_NAME: 'CompanyName',
  TOTAL_COUNT: 'totalCount',
  COMPARABLE_ID: 'comparableId',
  CONTAINS: 'Contains',
  BEGINS_WITH: 'Begins With',
  DIALOG_CONFIRM_MSG: 'Please Confirm',
  DIALOG_CONFIRM_RESULT_YES_MSG: 'Yes',
  DIALOG_CONFIRM_RESULT_NO_MSG: 'No',
  ADD_FILTER_CLICK_AND_CONTINUE: 'addFilterClickAndContinue',
  //Button
  ADD_FILTER_AND_CLOSE: 'Add Filter and Close',
  ADD_FILTER_AND_CONTINUE: 'Add Filter and Continue',
  ADD_FILTER: 'Add Filter',
  FOOTER_PAGINATOR: 'footerPaginator',
  UPDATE_FILTER: 'Update Filter',
  UPDATE_FILTER_AND_CONTINUE: 'Update Filter and Continue',
};

export const LoggerMessages = {
  LOGGER_NGONINIT: 'ngOnInit',
  LOGGER_START: 'Start',
  LOGGER_FILTERTYPECHANGED: 'filterTypeChanged',
  LOGGER_FINDNODERECURSIVE: 'findNodeRecursive',
  LOGGER_FLATTENTREE: 'flattenTree',
  LOGGER_CLOSE: 'close',
  UPDATE_READONLY: 'updateReadOnly',
};

export const UrlQueryParamsPlaceholder = {
  KEY_ID: '#KeyId',
  VENDOR_XREF: '[VendorXref]',
};

export const NonBvdComparableLinks = {
  SEC_URL: 'https://www.sec.gov/cgi-bin/browse-edgar?type=10-K&dateb=&owner=include&count=40&action=getcompany&CIK=#KeyId',
  SEC_DEFAULT_URL: 'https://www.sec.gov/edgar/searchedgar/companysearch.html',
  ONESOURCE_URL: 'https://app.dnbhoovers.com/company/[VendorXref]#report/financial_report',
};

export enum InputPlaceholder {
  NotAvailable = 'N/A',
}

export const FinancialReviewDialogMessages = {
  CONFITM_TITLE: 'Please Confirm',
  CONFIRM_YES: 'Yes',
  CONFIRM_NO: 'No',
  MANAGE_FR_UNSAVED_MSG: 'Are you sure you want to leave this page without saving your changes?',
  DB_SELECTION_CHANGED_MSG: '<br/> • Database selection for financial analysis changed',
  CURRENCY_SELECTION_CHANGED_MSG: '<br/> • Currency selection changed',
};

export const InterestRateDialogMessages = {
  CONFITM_TITLE: 'Please Confirm',
  CONFIRM_YES: 'Yes',
  CONFIRM_NO: 'No',
  DELETE_IRFILE_CONFIRM: 'Are you sure you want to delete this Interest rate file?', //DeleteInterestRateFile
  DELETE_IRSOURCE_CONFIRM: 'Are you sure you want to delete this Interest rate source?', //DeleteInterestRateSource
  MANAGE_IR_UNSAVED_MSG: 'Updates on this page have not been saved. Are you sure you want exit without saving?  Yes or No.', //ManageInterestRateFileUnsavedMsg
  IR_FILE_SOURCE_REQD_MSG:
    'Note that either Document or Source is mandatory. Please upload a new interest rate document or enter Source and click on Edit button, and try again.', //EditInterestRateFileMsg

  ACCEPTED_FILE_EXTENSTIONS: 'xls,xlsx,pdf,doc,docx,txt',
  EDIT_INTEREST_RATE_TEXT: 'Edit',
  ADD_INTEREST_RATE_TEXT: 'Add',

  TITLE_TEXT: ' Interest Rate Source',
  ADD_SUCCESS_MSG: ' Interest Rate data added successfully',
  ADD_FAILURE_MSG: ' Interest Rate data failed to add',

  EDIT_SUCCESS_MSG: ' Interest Rate data edited successfully',
  EDIT_FAILURE_MSG: ' Interest Rate data failed to edit',

  DELETE_FILE_SUCCESS_MSG: 'Interest Rate file deleted successfully',
  DELETE_FILE_FAILURE_MSG: ' Interest Rate file failed to delete',

  DELETE_SOURCE_SUCCESS_MSG: 'Interest Rate Source deleted successfully',
  DELETE_SOURCE_FAILURE_MSG: ' Interest Rate source failed to delete',

  INTERESTRATE_VALIDATION_MSG: 'Please enter interest rate %',
  INTERESTRATESOURCE_VALIDATION_MSG: 'Either of Interest Rate document or source Required',

  IR_DROPDOWN_DEFAULT_VAL: 'Choose Existing File',
  DECIMAL_ONLY_MSG: 'Please input only numeric values with up to two decimal places.',

  RESULT_TITLE: 'Result',
  OK_TITLE: 'Ok',
};

export const CompustatNA = {
  DatabaseId: '9',
  CSO: 'CSO',
  CSR: 'CSR',
};

export enum ValidationMessage {
  CompletedTestedPartyNotPresent = 'At least one completed tested party should be present to generate this report.',
  MasterMatrixNotComplete = 'The Final Results Matrix shall be complete with a status of either Accepted or Rejected for all comparables in order to generate this report.',
}

export const ModalFullWidthMode = {
  FULL_SCREEN_CSS_CLASS: 'modal-fs',
  FULL_SCREEN_EXIT_CSS_CLASS: 'modal-lg',
  CSS_CLASS: 'modal-dialog',
};

export const LocalStorage = {
  SEARCHFILTERS: 'searchFilters_',
};
